import Delete from "@mui/icons-material/Delete";
import Grid2 from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import React from "react";
import { useFormContext } from "react-hook-form";
import FormTextField from "../../Common/FormTextField";
import { getFieldPath } from "../../Common/SchemaUtils";

const NameFormFields: React.FC<{
  extractionId: string;
  extractionPath?: string;
  label?: string;
  remove?: Function;
}> = ({ extractionId, extractionPath, remove }) => {
  const { control } = useFormContext();
  return (
    <Grid2
      container
      spacing={2}
      key={getFieldPath([extractionId, extractionPath])}
      sx={{ alignItems: "center" }}
    >
      <Grid2 size={2}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.civility`}
          control={control}
          label="Civilité"
        />
      </Grid2>
      <Grid2 size={5}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.firstname`}
          control={control}
          label="Prénom"
        />
      </Grid2>
      <Grid2 size={remove !== undefined ? 4 : 5}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.lastname`}
          control={control}
          label="Nom de famille"
        />
      </Grid2>
      {remove !== undefined && (
        <Grid2 size={1} sx={{ textAlign: "right", pt: 0.5 }}>
          <IconButton
            onClick={() => {
              remove();
            }}
            className="rounded-full"
            size="small"
          >
            <Delete color="error" />
          </IconButton>
        </Grid2>
      )}
    </Grid2>
  );
};

export default NameFormFields;
